import React from 'react';

import { ConvertToAlineButton } from 'src/editor/toolbars/editor-app-bars/DocumentAppBarButtons';

export function TemplateAppBarButtons(): JSX.Element | null {
  return <ConvertToAlineButton buttonProps={{ color: 'primary', variant: 'contained' }} />;
}
